module.exports = __webpack_public_path__ + "static/img/sm_4.be8a12e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_4.png
// module id = NZdi
// module chunks = 0